import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBankDeposit } from "src/models/Prices/Bank.models";

interface BankDepositState {
  bankDeposits: IBankDeposit[];
  bankDepositToEdit: IBankDeposit | null;
}

const initialState: BankDepositState = {
  bankDeposits: [],
  bankDepositToEdit: null,
};

const BankDepositSlice = createSlice({
  name: "BankDeposit",
  initialState,
  reducers: {
    setBankDepositList: (state, action: PayloadAction<IBankDeposit[]>) => {
      state.bankDeposits = action.payload;
    },
    setBankDepositToEdit: (state, action: PayloadAction<IBankDeposit | null>) => {
      state.bankDepositToEdit = action.payload;
    },
    concatListBankDeposit: (state: BankDepositState, action: PayloadAction<IBankDeposit[]>) => {
      state.bankDeposits = [...state.bankDeposits.concat(action.payload)];
    },
    addBankDeposit: (state, action: PayloadAction<IBankDeposit>) => {
      state.bankDeposits.push(action.payload);
    },
    updateBankDeposit: (state, action: PayloadAction<IBankDeposit>) => {
      let itemIndex = state.bankDeposits.findIndex(
        item => item.bankDepositId === action.payload.bankDepositId
      );
      if (itemIndex !== -1) state.bankDeposits[itemIndex] = action.payload;
    },
    updateBankDepositStatus: (state, action: PayloadAction<IBankDeposit>) => {
      let itemIndex = state.bankDeposits.findIndex(
        item => item.bankDepositId === action.payload.bankDepositId
      );
      if (itemIndex !== -1) state.bankDeposits[itemIndex] = action.payload;
    },
    deleteBankDeposit: (state, action: PayloadAction<number>) => {
      const newArray = state.bankDeposits.filter(
        item => item.bankDepositId !== action.payload
      );
      state.bankDeposits = newArray;
    },
  },
});

export const {
  setBankDepositList,
  concatListBankDeposit,
  setBankDepositToEdit,
  addBankDeposit,
  updateBankDeposit,
  updateBankDepositStatus,
  deleteBankDeposit,
} = BankDepositSlice.actions;

export default BankDepositSlice.reducer;
